







import { defineComponent, computed } from '@vue/composition-api';
import DriftFacade from '~/components/DriftFacade.vue';

export default defineComponent({
  name: 'BaseLayout',
  components: {
    DriftFacade,
  },
  setup() {
    const { $store } = useNuxtApp();
    const routesWithFacade = ['shop', 'shop-products-fightcamp-connect', 'shop-products-fightcamp-core', 'shop-products-fightcamp-elite'];
    const displayFacade = computed(() => routesWithFacade.includes($store.getters.currentRoute?.name));

    return {
      displayFacade,
    };
  },
});
